import { render, staticRenderFns } from "./CursosPromo.vue?vue&type=template&id=e3d7e9bc"
import script from "./CursosPromo.vue?vue&type=script&lang=js"
export * from "./CursosPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports